// Base por ruta relativa, no desde el barrel (igual que ProcessConfigPayExemption y el resto de
// hermanas): evita el ciclo que dejaba `extends` en undefined.
import ProcessConfig from './ProcessConfig';

export default class ProcessConfigExam extends ProcessConfig {
    constructor(data: any) {
        super(data);
        this.type = BigInt(0);
    }

    public toServer() {
        return {
            id: this.id,
            title: this.title,
            active: this.active
        };
    }
}
